/**
 * Feature cards data for the homepage grid
 * Following Next.js best practices - this is a pure data file
 */

import type { LucideIcon } from "lucide-react";
import {
  FileText,
  BarChart3,
  AlertTriangle,
  Clock,
  Package,
  Wrench,
  CheckCircle2,
  ClipboardCheck,
  ShoppingCart,
  RefreshCw,
  Archive,
  Activity,
  Settings,
  GitBranch,
  User,
  Shield,
  BookOpen,
  Calendar,
  TrendingUp,
} from "lucide-react";

export interface FeatureCard {
  id: string;
  label: string;
  icon: LucideIcon;
  href: string;
  bgColor: string; // Background color class
  iconColor: string; // Icon color class
}

export const featureCards: FeatureCard[] = [
  // Row 1
  {
    id: "feature-1",
    label: "생산지시현황",
    icon: FileText,
    href: "/production-order",
    bgColor: "bg-blue-100",
    iconColor: "text-blue-600",
  },
  {
    id: "feature-2",
    label: "실적등록",
    icon: BarChart3,
    href: "/result-registration",
    bgColor: "bg-green-100",
    iconColor: "text-green-600",
  },
  {
    id: "feature-3",
    label: "불량등록",
    icon: AlertTriangle,
    href: "/defect-registration",
    bgColor: "bg-red-100",
    iconColor: "text-red-600",
  },
  {
    id: "feature-4",
    label: "비가동등록",
    icon: Clock,
    href: "/downtime-registration",
    bgColor: "bg-orange-100",
    iconColor: "text-orange-600",
  },
  {
    id: "feature-5",
    label: "자재투입",
    icon: Package,
    href: "/material-input",
    bgColor: "bg-purple-100",
    iconColor: "text-purple-600",
  },
  // Row 2
  {
    id: "feature-6",
    label: "금형투입",
    icon: Wrench,
    href: "/mold-input",
    bgColor: "bg-blue-100",
    iconColor: "text-blue-600",
  },
  {
    id: "feature-7",
    label: "자주검사",
    icon: CheckCircle2,
    href: "/self-inspection",
    bgColor: "bg-cyan-100",
    iconColor: "text-cyan-600",
  },
  {
    id: "feature-8",
    label: "순회검사",
    icon: ClipboardCheck,
    href: "/patrol-inspection",
    bgColor: "bg-sky-100",
    iconColor: "text-sky-600",
  },
  {
    id: "feature-9",
    label: "자재요청",
    icon: ShoppingCart,
    href: "/material-request",
    bgColor: "bg-yellow-100",
    iconColor: "text-yellow-600",
  },
  {
    id: "feature-10",
    label: "금형회수",
    icon: RefreshCw,
    href: "/mold-return",
    bgColor: "bg-pink-100",
    iconColor: "text-pink-600",
  },
  // Row 3
  {
    id: "feature-11",
    label: "재고확인",
    icon: Archive,
    href: "/inventory-check",
    bgColor: "bg-green-100",
    iconColor: "text-green-600",
  },
  {
    id: "feature-12",
    label: "재공확인",
    icon: Activity,
    href: "/wip-check",
    bgColor: "bg-gray-100",
    iconColor: "text-gray-600",
  },
  {
    id: "feature-13",
    label: "설비점검",
    icon: Settings,
    href: "/equipment-check",
    bgColor: "bg-slate-100",
    iconColor: "text-slate-600",
  },
  {
    id: "feature-14",
    label: "공정관리",
    icon: GitBranch,
    href: "/process-management",
    bgColor: "bg-blue-100",
    iconColor: "text-blue-600",
  },
  {
    id: "feature-15",
    label: "작업지시",
    icon: ClipboardCheck,
    href: "/work-orders",
    bgColor: "bg-purple-100",
    iconColor: "text-purple-600",
  },
  // Row 4
  {
    id: "feature-16",
    label: "품질관리",
    icon: Shield,
    href: "/quality-management",
    bgColor: "bg-amber-100",
    iconColor: "text-amber-600",
  },
  {
    id: "feature-17",
    label: "안전점검",
    icon: Shield,
    href: "/safety-check",
    bgColor: "bg-red-100",
    iconColor: "text-red-600",
  },
  {
    id: "feature-18",
    label: "교육관리",
    icon: BookOpen,
    href: "/training",
    bgColor: "bg-lime-100",
    iconColor: "text-lime-600",
  },
  {
    id: "feature-19",
    label: "생산계획",
    icon: Calendar,
    href: "/production-plan",
    bgColor: "bg-sky-100",
    iconColor: "text-sky-600",
  },
  {
    id: "feature-20",
    label: "데이터분석",
    icon: TrendingUp,
    href: "/data-analysis",
    bgColor: "bg-pink-100",
    iconColor: "text-pink-600",
  },
];

